export default {"src":"/_next/static/media/xin.ab08bc61.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};